/* eslint-disable jsx-a11y/img-redundant-alt */
import { ChevronLeft, ChevronRight, Fullscreen, Maximize2, X, ZoomIn, ZoomOut } from 'lucide-react';
import { Activity, useState } from 'react';

const ProductImagesSlider = ({ images = [] }) => {
    const [selectedImage, setSelectedImage] = useState(0);

    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const [lightboxZoom, setLightboxZoom] = useState(1);

    const isImageAvailable = images && images?.length > 0;
    const hasMultiple = images.length > 1;

    const handlePrevious = () => {
        setSelectedImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setSelectedImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    const handleThumbnailClick = (index) => {
        setSelectedImage(index);
    };

    const zoomIn = () => setLightboxZoom((prev) => Math.min(prev + 0.2, 3));
    const zoomOut = () => setLightboxZoom((prev) => Math.max(prev - 0.2, 1));
    const resetZoom = () => setLightboxZoom(1);

    const closeLightbox = () => {
        setLightboxZoom(1);
        setSelectedImage(0);
        setIsLightboxOpen(false);
    };

    if (!images || images.length === 0) {
        return (
            <div className="product-images-slider">
                <div className="main-image-container">
                    <div className="no-image">No images available</div>
                </div>
            </div>
        );
    }

    return (
        <div className="product-images-slider">
            <div className="main-image-container">
                <img
                    src={images[selectedImage]}
                    alt={`Product ${selectedImage + 1}`}
                    className="main-image"
                />

                <button
                    className="expand-button"
                    onClick={() => setIsLightboxOpen(true)}
                    aria-label="Expand image"
                >
                    <Maximize2 size={20} />
                </button>

                <Activity mode={isImageAvailable ? 'visible' : 'hidden'}>
                    <button
                        className="nav-button prev-button"
                        onClick={handlePrevious}
                        aria-label="Previous image"
                    >
                        <ChevronLeft size={24} />
                    </button>
                    <button className="nav-button next-button" onClick={handleNext} aria-label="Next image">
                        <ChevronRight size={24} />
                    </button>
                </Activity>

                <div className="image-counter">
                    {selectedImage + 1} / {images.length}
                </div>
            </div>
            <Activity mode={hasMultiple ? 'visible' : 'hidden'}>
                <div className="thumbnails-container">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className={`thumbnail ${index === selectedImage ? 'active' : ''}`}
                            onClick={() => handleThumbnailClick(index)}
                        >
                            <img src={image} alt={`Thumbnail ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </Activity>


            <Activity mode={isImageAvailable && isLightboxOpen ? 'visible' : 'hidden'}>
                <div className="lightbox" onClick={() => setIsLightboxOpen(false)}>
                    <div className="lightbox-panel" onClick={(e) => e.stopPropagation()}>
                        <button onClick={zoomIn} aria-label="Zoom In" disabled={lightboxZoom >= 3}>
                            <ZoomIn />
                        </button>
                        <button onClick={zoomOut} aria-label="Zoom Out" disabled={lightboxZoom <= 1}>
                            <ZoomOut />
                        </button>
                        <button onClick={resetZoom} aria-label="Reset Zoom" disabled={lightboxZoom === 1}>
                            <Fullscreen />
                        </button>
                        <button onClick={closeLightbox} aria-label="Close">
                            <X />
                        </button>
                    </div>

                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <img
                            src={images[selectedImage]}
                            alt={`Product image ${selectedImage + 1} - Lightbox view`}
                            className="lightbox-image"
                            style={{
                                transform: `scale(${lightboxZoom})`,
                                transition: 'transform 0.3s ease',
                                cursor: lightboxZoom > 1 ? 'grab' : 'zoom-in',
                            }}
                        />

                        <Activity mode={hasMultiple ? 'visible' : 'hidden'}>
                            <button className="lightbox-nav prev" onClick={handlePrevious} aria-label="Previous image">
                                <ChevronLeft size={32} />
                            </button>

                            <button className="lightbox-nav next" onClick={handleNext} aria-label="Next image">
                                <ChevronRight size={32} />
                            </button>
                        </Activity>

                        <div className="lightbox-counter">
                            {selectedImage + 1} / {images.length}
                        </div>
                    </div>
                </div>
            </Activity>
        </div>
    );
};

export default ProductImagesSlider;
